import SmsTemplate from "../singleton/sms-template";
import Sms from "../singleton/sms";
import ServiceUtils from "../singleton/service-utils";

export default {

    getEmissions: Sms.getEmissions.bind(Sms),

    getSubstitutions: ServiceUtils.getPathSubstitutions.bind(ServiceUtils),

    send: Sms.send.bind(Sms),

    getTestAddress: Sms.getTestAddress.bind(Sms),

    Template: {

        getAll: SmsTemplate.getAll.bind(SmsTemplate),

        get: SmsTemplate.get.bind(SmsTemplate),

        load: SmsTemplate.load.bind(SmsTemplate),

        create: SmsTemplate.create.bind(SmsTemplate),

        update: SmsTemplate.update.bind(SmsTemplate),

        delete: SmsTemplate.delete.bind(SmsTemplate),

        setOrder: SmsTemplate.setOrder.bind(SmsTemplate)
    }

}